import React, { useEffect, useState, useCallback, useRef } from "react";
import { Dropdown, Modal, Button, Tabs, Tab, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Formik, Field, Form as FormikForm, ErrorMessage } from "formik";
import * as Yup from "yup";
import * as XLSX from "xlsx";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import Spinner from "../components/Common/Spinner";
import {
  addFile,
  createNewAdmin,
  deleteAdmin,
  deleteAds,
  getUrl,
  updateAdminInfo,
  updateAdminStatus,
  updateListingStatus,
  vendorRequest,
} from "../../services/Admin/adminServices";
import Pagination from "../components/Pagination";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserList2, interestedAds, exportExpressInterestBookingList } from "../../services/UserServices/UserService";
import "react-phone-input-2/lib/style.css";
import { useSearchParams } from "react-router-dom";
import {
  addAdsLimit,
  getFlatList,
  getWaitList,
} from "../../services/UserServices/UserService";
import { set } from "lodash";
import LocationSearchDropdown from "../components/LocationAdd";

const ReadMoreText = ({ text, maxLength = 30, maxWidth = "220px" }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!text) return "_";

  const textStr = typeof text === "string" ? text : String(text);
  const formattedText = textStr.charAt(0).toUpperCase() + textStr.slice(1);

  if (formattedText.length <= maxLength) {
    return <span style={{ whiteSpace: "normal", wordBreak: "break-word" }}>{formattedText}</span>;
  }

  return (
    <div style={{ maxWidth: isExpanded ? "350px" : maxWidth, wordBreak: "break-word", whiteSpace: "normal" }}>
      {isExpanded ? formattedText : `${formattedText.slice(0, maxLength)}...`}
      <button
        type="button"
        className="btn btn-link p-0 text-primary fw-semibold ms-1"
        style={{ fontSize: "12px", textDecoration: "none", boxShadow: "none", verticalAlign: "baseline" }}
        onClick={(e) => {
          e.stopPropagation();
          setIsExpanded(!isExpanded);
        }}
      >
        {isExpanded ? "Read Less" : "Read More"}
      </button>
    </div>
  );
};

const ExpressInterest = () => {
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const page = searchParams.get("page");

  const [locationText, setLocationText] = useState("");
  const [search, setSearch] = useState({
    lat: "",
    long: "",
  });
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const roleData = useSelector((state) => state.role.roles);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [currentPage, setCurrentPage] = useState(
    location.state?.currentPage ?? 0,
  );
  const [itemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [activeTab, setActiveTab] = useState(
    location.state?.activeTab || "User"
  );
  const [type, setType] = useState("");
  const [limitModal, setLimitModal] = useState(false);
  const [adsLimit, setAdsLimit] = useState("");
  const [user, setUser] = useState(""); // Selected User Object or ID
  const [usersList, setUsersList] = useState([]); // List of users loaded
  const [userSearch, setUserSearch] = useState(""); // Search input for user dropdown
  const [usersPage, setUsersPage] = useState(0); // Infinite scroll page tracker
  const [usersLoading, setUsersLoading] = useState(false);
  const [hasMoreUsers, setHasMoreUsers] = useState(true);
  const [expiry, setExpiry] = useState("");

  const [showExportModal, setShowExportModal] = useState(false);
  const [exportType, setExportType] = useState("excel");
  const [exportStartDate, setExportStartDate] = useState("");
  const [exportEndDate, setExportEndDate] = useState("");
  const [exportLoading, setExportLoading] = useState(false);
  // 🌟 Added state for the Confirmation Modal
  const [confirmState, setConfirmState] = useState({
    show: false,
    action: null,
    id: null,
    status: null,
    message: "",
  });
  useEffect(() => {
    if (page !== null) {
      setCurrentPage(Number(page) || 0);
    }
  }, [searchParams]);

  useEffect(() => {
    if (currentPage !== undefined) {
      navigate(".", {
        replace: true,
        state: { ...location.state, currentPage, activeTab },
      });
    }
  }, [currentPage, activeTab]);
  const [rejectReason, setRejectReason] = useState("");
  const [adType, setAdType] = useState("");
  const navigate = useNavigate();
  const [uploading, setUploading] = useState(false);
  const [preview, setPreview] = useState("");
  const fileInputRef = useRef(null);
  const [imageLoading, setImageLoading] = useState(false);
  const [submit, setSubmit] = useState(false);
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="12" cy="5" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="19" r="2"></circle>
      </g>
    </svg>
  );

  const fetchUsers = useCallback(
    async (pageNum, searchStr) => {
      try {
        setUsersLoading(true);
        const response = await getUserList2(
          pageNum,
          10,
          "Verified",
          searchStr
        );

        const newUsers = response?.data?.data?.data || [];
        const totalUsers = response?.data?.data?.total || 0;

        setUsersList((prev) => {
          const updated = pageNum === 0 ? newUsers : [...prev, ...newUsers];
          setHasMoreUsers(updated.length < totalUsers);
          return updated;
        });
      } catch (error) {
        console.error("Failed to load users:", error);
      } finally {
        setUsersLoading(false);
      }
    },
    []
  );

  // Initial load of users
  useEffect(() => {
    fetchUsers(0, "");
  }, [fetchUsers]);

  // Debounced user search
  useEffect(() => {
    const timer = setTimeout(() => {
      setUsersPage(0);
      fetchUsers(0, userSearch);
    }, 300);

    return () => clearTimeout(timer);
  }, [userSearch, fetchUsers]);

  // Fetch next page of users on scroll
  useEffect(() => {
    if (usersPage > 0) {
      fetchUsers(usersPage, userSearch);
    }
  }, [usersPage, userSearch, fetchUsers]);

  const handleDropdownScroll = (e) => {
    const target = e.target;
    if (target.scrollHeight - target.scrollTop <= target.clientHeight + 20) {
      if (!usersLoading && hasMoreUsers) {
        setUsersPage((prevPage) => prevPage + 1);
      }
    }
  };

  const fetchAdmins = useCallback(async () => {
    try {
      setLoading(true);
      const response = await interestedAds(
        currentPage,
        itemsPerPage,
        search.lat,
        search.long,
        adType,
        user
      );
      setAdmins(response?.data?.data?.data || []);
      setTotalItems(response?.data?.data?.total || 0);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load data");
    } finally {
      setLoading(false);
    }
  }, [currentPage, itemsPerPage, search, adType, user]);

  useEffect(() => {
    fetchAdmins();
  }, [fetchAdmins]);

  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const isFilterActive =
    search.lat || search.long || startDate || endDate || adType || user || locationText;

  const handleClear = () => {
    setSearch({ lat: "", long: "" });
    setStartDate("");
    setLocationText("");
    setEndDate("");
    setAdType("");
    setUser("");
    setUserSearch("");
  };


  const openExportModal = () => {
    setExportStartDate(startDate || "");
    setExportEndDate(endDate || "");
    setShowExportModal(true);
  };

  const handleExportSubmit = async (e) => {
    e.preventDefault();
    if (!exportStartDate || !exportEndDate) {
      toast.error("Start Date and End Date are compulsory for export");
      return;
    }

    if (exportStartDate > exportEndDate) {
      toast.error("Start Date cannot be after End Date");
      return;
    }

    try {
      setExportLoading(true);
      const res = await exportExpressInterestBookingList(
        exportStartDate,
        exportEndDate
      );

      const rawData = res?.data?.data;
      let list = [];
      if (Array.isArray(rawData)) {
        list = rawData;
      } else if (rawData?.data && Array.isArray(rawData.data)) {
        list = rawData.data;
      } else if (rawData?.list && Array.isArray(rawData.list)) {
        list = rawData.list;
      } else if (rawData?.bookingList && Array.isArray(rawData.bookingList)) {
        list = rawData.bookingList;
      } else if (rawData?.expressInterestList && Array.isArray(rawData.expressInterestList)) {
        list = rawData.expressInterestList;
      }

      if (!list || list.length === 0) {
        toast.error("No data found for the selected criteria");
        return;
      }

      const csvData = list.map((admin, index) => {
        const flat = admin.title
          ? `${admin.title.charAt(0).toUpperCase()}${admin.title.slice(1)}`
          : "_";

        const address = admin.address || "_";
        const interestCount = admin.expressInterestCounts || "_";
        const registeredBy = admin.user?.name
          ? `${admin.user.name.charAt(0).toUpperCase()}${admin.user.name.slice(1)}`
          : "_";

        const registeredAt = admin.updatedAt
          ? new Date(admin.updatedAt).toLocaleDateString()
          : "_";

        return {
          "Sr No.": index + 1,
          Flat: flat,
          Address: address,
          "Interested Users Count": interestCount,
          "Registered By": registeredBy,
          "Registered At": registeredAt,
        };
      });

      if (exportType === "excel") {
        const worksheet = XLSX.utils.json_to_sheet(csvData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Interested Ads");
        XLSX.writeFile(
          workbook,
          `express_interest_export_${exportStartDate}_to_${exportEndDate}.xlsx`
        );
        toast.success("Excel exported successfully");
      } else {
        const headers = Object.keys(csvData[0]);
        const csvContent = [
          headers.join(","),
          ...csvData.map((row) =>
            headers
              .map((header) => `"${String(row[header] ?? "").replace(/"/g, '""')}"`)
              .join(",")
          ),
        ].join("\n");

        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.setAttribute(
          "download",
          `express_interest_export_${exportStartDate}_to_${exportEndDate}.csv`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        toast.success("CSV exported successfully");
      }
      setShowExportModal(false);
    } catch (error) {
      console.error("Export Error:", error);
      toast.error(error?.response?.data?.message || "Failed to export data");
    } finally {
      setExportLoading(false);
    }
  };

  const today = new Date().toISOString().split("T")[0];


  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h1 style={{ color: "#E5484D" }}>Interested Ads</h1>
        <div className="d-flex align-items-center gap-2">
          <button
            onClick={openExportModal}
            className="btn btn-sm text-white d-flex align-items-center gap-2 shadow-sm px-3 py-2"
            style={{
              backgroundColor: "#E5484D",
              borderRadius: "0.5rem",
              border: "none",
            }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="7 10 12 15 17 10" />
              <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
            Export Interested Ads
          </button>

        </div>
      </div>

      <div className="pb-2 d-flex flex-wrap justify-content-between gap-2 align-items-end mb-4">
        <div className="flex-grow-1" style={{ minWidth: "200px" }}>
          <label className="form-label mb-1" style={{ fontSize: "12px", color: "#6c757d" }}>
            Location
          </label>

          <LocationSearchDropdown
            value={locationText}
            onChange={setLocationText}
            onSelect={(locationData) => {
              setLocationText(locationData.name);
              const lat = locationData.location?.coordinates?.[1];
              const long = locationData.location?.coordinates?.[0];

              setSearch({ lat, long });
            }}
          />
        </div>


        <div>
          <label className="form-label mb-1" style={{ fontSize: "12px", color: "#6c757d" }}>
            Ad Type
          </label>

          <select
            className="form-control"
            value={adType}
            style={{ borderRadius: "0.5rem", borderColor: "#E5484D", height: "42px" }}
            onChange={(e) => setAdType(e.target.value)}
          >
            <option value="">All</option>
            <option value="Flat">Flat</option>
            <option value="Flatmate">Flatmate</option>{" "}
          </select>
        </div>

        <div>
          <label className="form-label mb-1" style={{ fontSize: "12px", color: "#6c757d" }}>
            Interest Expressed by
          </label>
          <Dropdown>
            <Dropdown.Toggle
              variant="outline-secondary"
              id="dropdown-user-scroll"
              className="d-flex justify-content-between align-items-center w-100"
              style={{
                minWidth: "200px",
                height: "42px",
                borderRadius: "0.5rem",
                borderColor: "#E5484D",
              }}
            >
              {user
                ? usersList.find((u) => u._id === user)?.name || "User Selected"
                : "Select User"}
            </Dropdown.Toggle>

            <Dropdown.Menu
              onScroll={handleDropdownScroll}
              className="shadow-lg border-0 rounded-3 p-0"
              style={{
                maxHeight: "300px",
                overflowY: "auto",
                margin: "0px",
                width: "320px",
              }}
            >
              <div
                className="p-2 sticky-top bg-white border-bottom shadow-sm"
                onClick={(e) => e.stopPropagation()}
                style={{ zIndex: 10 }}
              >
                <div className="position-relative">
                  <input
                    type="text"
                    className="form-control form-control-sm pe-4"
                    placeholder="Search name or phone..."
                    value={userSearch}
                    onChange={(e) => setUserSearch(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                    style={{
                      borderRadius: "0.375rem",
                      fontSize: "12px",
                      borderColor: "#E5484D",
                    }}
                  />
                  {userSearch && (
                    <button
                      type="button"
                      className="btn-close position-absolute end-0 top-50 translate-middle-y me-2"
                      style={{ fontSize: "10px" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setUserSearch("");
                      }}
                    />
                  )}
                </div>
              </div>

              <Dropdown.Item
                onClick={() => setUser("")}
                className="d-flex align-items-center gap-2 py-2 px-3 border-bottom"
                style={{
                  cursor: "pointer",
                  backgroundColor: user === "" ? "#FEE2E2" : "transparent",
                  color: user === "" ? "#E5484D" : "#1F2937",
                  fontWeight: user === "" ? "600" : "500",
                }}
              >
                <div
                  className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 fw-bold"
                  style={{
                    width: "32px",
                    height: "32px",
                    backgroundColor: user === "" ? "#E5484D" : "#E5E7EB",
                    color: user === "" ? "#FFFFFF" : "#6B7280",
                    fontSize: "12px",
                  }}
                >
                  👥
                </div>
                <div className="flex-grow-1" style={{ fontSize: "13px" }}>
                  All Users
                </div>
                {user === "" && (
                  <span className="ms-auto fw-bold" style={{ color: "#E5484D", fontSize: "14px" }}>
                    ✓
                  </span>
                )}
              </Dropdown.Item>

              {usersList.map((usr) => {
                const isSelected = user === usr._id;
                const initial = usr.name ? usr.name.charAt(0).toUpperCase() : "U";
                const fullName = usr.name ? usr.name.charAt(0).toUpperCase() + usr.name.slice(1) : "Unknown";
                const contactInfo = usr.phoneNumber
                  ? `${usr.countryCode || ""} ${usr.phoneNumber}`.trim()
                  : usr.email || "No contact";

                return (
                  <Dropdown.Item
                    key={usr._id}
                    onClick={() => setUser(usr._id)}
                    className="d-flex align-items-center gap-2 py-2 px-3 border-bottom border-light"
                    style={{
                      cursor: "pointer",
                      backgroundColor: isSelected ? "#FEE2E2" : "transparent",
                      color: isSelected ? "#E5484D" : "#1F2937",
                      whiteSpace: "normal",
                    }}
                  >
                    <div
                      className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 fw-bold"
                      style={{
                        width: "32px",
                        height: "32px",
                        backgroundColor: isSelected ? "#E5484D" : "#F3F4F6",
                        color: isSelected ? "#FFFFFF" : "#4B5563",
                        fontSize: "13px",
                      }}
                    >
                      {initial}
                    </div>

                    <div className="flex-grow-1 overflow-hidden" style={{ lineHeight: "1.25" }}>
                      <div className="fw-semibold text-truncate" style={{ fontSize: "13px", color: isSelected ? "#E5484D" : "#111827" }}>
                        {fullName}
                      </div>
                      <div className="text-muted text-truncate" style={{ fontSize: "11px" }}>
                        {contactInfo}
                      </div>
                    </div>

                    {isSelected && (
                      <span className="ms-auto flex-shrink-0 fw-bold" style={{ color: "#E5484D", fontSize: "14px" }}>
                        ✓
                      </span>
                    )}
                  </Dropdown.Item>
                );
              })}

              {usersLoading && (
                <div className="text-center py-2 text-muted small">
                  Loading users...
                </div>
              )}

              {!usersLoading && usersList.length === 0 && (
                <div className="text-center py-2 text-muted small">
                  No users found
                </div>
              )}

              {!hasMoreUsers && usersList.length > 0 && (
                <div
                  className="text-center py-2 text-muted small"
                  style={{ fontSize: "10px" }}
                >
                  End of list
                </div>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </div>



        {isFilterActive && (
          <div>
            <button
              className="btn btn-outline-danger"
              onClick={handleClear}
              style={{ borderRadius: "0.5rem", height: "42px" }}
            >
              Clear
            </button>
          </div>
        )}
      </div>



      {loading ? (
        <Spinner />
      ) : (
        <div className="table-responsive">
          <table className="table table-striped align-middle shadow-sm" style={{

            width: "100%",
          }}>
            <thead className="table-light">
              <tr>
                <th>Sr No.</th>
                <th>Flat</th>


                <th style={{ minWidth: "180px" }}>Address</th>

                <th> Interested Users Count</th>

                {/* <th>Expired On</th> */}
                <th>Registered By</th>
                <th>Registered At</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {admins?.length > 0 ? (
                admins.map((admin, index) => (
                  <tr key={admin._id || index}>
                    <td>{currentPage * itemsPerPage + index + 1}</td>
                    <td>
                      {admin.title
                        ? `${admin.title
                          .charAt(0)
                          .toUpperCase()}${admin.title.slice(1)}`
                        : "_"}
                    </td>

                    <td>
                      <ReadMoreText text={admin.address} maxLength={30} maxWidth="200px" />
                    </td>




                    {/* <td>
                      {admin?.adminApproveStatus?.toLowerCase() === "approved"
                        ? admin?.isExpire
                          ? new Date(admin?.updatedAt).toLocaleDateString()
                          : ` ${admin?.remainingExpireDays} days left  ${new Date(
                              new Date(admin.expireDate).getTime() +
                                admin.remainingExpireDays * 24 * 60 * 60 * 1000,
                            ).toLocaleDateString()}`
                        : "_"}
                    </td> */}
                    <td>{admin.expressInterestCounts}</td>

                    <td
                      onClick={() =>
                        roleData
                          ? (roleData?.userManagement?.isRead ||
                            roleData?.misManagement.isRead) &&
                          navigate(`/user-detail/${admin?.user?._id}`)
                          : navigate(`/user-detail/${admin?.user?._id}`, {
                            state: {
                              from: `${location.pathname}?page=${currentPage}`,
                            },
                          })
                      }
                      className="cursor-pointer"
                      style={{ color: "blue" }}
                    >
                      {admin?.user?.name.charAt(0).toUpperCase() +
                        admin?.user?.name.slice(1)}
                    </td>
                    <td>{new Date(admin?.updatedAt).toLocaleDateString()}</td>

                    <td style={{ textAlign: "center" }}>
                      <Dropdown>
                        <Dropdown.Toggle
                          variant="light"
                          id={`dropdown-basic-${index}`}
                          style={{ padding: "4px 8px" }}
                        >
                          {svg1}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() =>
                              navigate(`/interested-ad-detail/${admin._id}`)
                            }
                          >
                            Acceptance Details
                          </Dropdown.Item>




                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="10" className="text-center">
                    No data found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      <div className="card-footer clearfix mt-3">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center text-center text-md-start">
          <div
            className="dataTables_info fw-bold mbhandleCloseModal-3 mb-md-0"
            style={{ color: "#E5484D" }}
          >Total Ads : {totalItems}</div>
          <div className="d-flex align-items-center">
            {totalPages > 0 && (
              <Pagination
                pageCount={totalPages}
                pageValue={currentPage}
                setPage={setCurrentPage}
              />
            )}
          </div>
        </div>
      </div>

      {/* 🌟 Export Modal */}
      <Modal
        show={showExportModal}
        onHide={() => setShowExportModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "#E5484D" }}>Export Interested Ads Data</Modal.Title>
        </Modal.Header>
        <form onSubmit={handleExportSubmit}>
          <Modal.Body>
            <div className="mb-3">
              <label className="form-label fw-bold">Export Format</label>
              <select
                className="form-select"
                style={{ borderRadius: "0.5rem", borderColor: "#E5484D" }}
                value={exportType}
                onChange={(e) => setExportType(e.target.value)}
              >
                <option value="excel">Excel (.xlsx)</option>
                <option value="csv">CSV (.csv)</option>
              </select>
            </div>

            <div className="mb-3">
              <label className="form-label fw-bold">
                Start Date <span className="text-danger">*</span>
              </label>
              <input
                type="date"
                className="form-control"
                style={{ borderRadius: "0.5rem", borderColor: "#E5484D" }}
                max={today}
                value={exportStartDate}
                onChange={(e) => {
                  setExportStartDate(e.target.value);
                  if (exportEndDate && e.target.value > exportEndDate) {
                    setExportEndDate("");
                  }
                }}
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label fw-bold">
                End Date <span className="text-danger">*</span>
              </label>
              <input
                type="date"
                className="form-control"
                style={{ borderRadius: "0.5rem", borderColor: "#E5484D" }}
                min={exportStartDate}
                max={today}
                value={exportEndDate}
                onChange={(e) => setExportEndDate(e.target.value)}
                disabled={!exportStartDate}
                required
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowExportModal(false)}
              disabled={exportLoading}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              disabled={exportLoading}
              style={{
                backgroundColor: exportType === "excel" ? "#21a366" : "#E5484D",
                borderColor: exportType === "excel" ? "#21a366" : "#E5484D",
                color: "white",
              }}
            >
              {exportLoading ? "Exporting..." : exportType === "excel" ? "Export Excel" : "Export CSV"}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>

    </div>
  );
};

export default ExpressInterest;
